import HamburgerButton from "@/components/buttons/hamburger-button"
import { authStore } from "@/routes/login/auth-store"
import { useNavigate } from "react-router-dom"
import { langStore } from "@/stores/lang-store"
import { commonBundle } from "./header-const"

const HeaderWrapperMobile = ({ useBg = true, children }) => {
  const { lang } = langStore()

  const navigate = useNavigate()
  const { apiLogout, user_id } = authStore()

  const logoutAction = async () => {
    const success = await apiLogout()
    if (success) navigate("/", { replace: true })
  }

  return (
    <header
      className={`sticky top-0 left-0 right-0
        ${useBg ? "bg-white border-b border-b-gray-200" : ""} 
        flex justify-end items-center px-4 h-15 z-10
      `}
    >
      {children}

      <HamburgerButton>
        <div className="bg-white shadow-xl border border-gray-200 w-40 text-center">
          <p className="py-2.5 mx-3 border-b border-b-gray-300 text-sm font-bold">{user_id}</p>

          <button
            type="button"
            className="w-full py-2 px-3 hover:bg-toicos-navy hover:text-white cursor-pointer"
            onClick={() => navigate("/my")}
          >
            {commonBundle.myPage[lang]}
          </button>

          <button
            className="w-full py-2 px-3 hover:bg-toicos-navy hover:text-white cursor-pointer"
            onClick={logoutAction}
          >
            {commonBundle.logout[lang]}
          </button>
        </div>
      </HamburgerButton>
    </header>
  )
}

export default HeaderWrapperMobile
